import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, useField } from 'formik';
import { Form, Button } from 'react-bootstrap5';
import { ChromePicker } from 'react-color';

export default function ColorField(props) {
  const {
    id, name, label, hint, required, disabled,
  } = props;
  const [, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  return (
    <Form.Group className="mb-3" controlId={id}>
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className="d-flex align-items-center position-relative">
        {displayColorPicker && (
          <div className="position-absolute">
            <div
              className="position-fixed top-0 bottom-0 start-0 end-0"
              onClick={() => setDisplayColorPicker(false)}
              aria-hidden="true"
            />
            <ChromePicker color={value} onChange={(color) => setValue(color.hex)} />
          </div>
        )}

        <Button
          variant={null}
          disabled={disabled}
          className="p-1 d-flex align-items-center border"
          onClick={() => setDisplayColorPicker(true)}
        >
          <span className="px-3">{value}</span>
          <span
            className="d-inline-block rounded-1"
            style={{ width: '2rem', height: '2rem', backgroundColor: value }}
          />
        </Button>
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

ColorField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

ColorField.defaultProps = {
  label: '',
  hint: '',
  required: false,
  disabled: false,
};
